import { BranchDeleteUseCase } from '../../../../application';

export default class BranchDeleteService {
    
    async execute(event) {
        const data = await BranchDeleteUseCase(event);
        return data;
    }
}
